import React from 'react';

const ErrorIconDynamica = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M60.5 14.2c25.252 0 45.8 20.548 45.8 45.8s-20.548 45.8-45.8 45.8S14.7 85.252 14.7 60s20.548-45.8 45.8-45.8z'
        stroke='#FFD031'
        strokeWidth='4.4'
      />
      <path d='M74.784 74.284 46.5 46M46.216 74.284 74.5 46' stroke='#000' strokeWidth='4.4' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default ErrorIconDynamica;
